import React, { useEffect, useState } from 'react';
import { fetchRobloxData } from '../utils/robloxData';
import { BLOG_POSTS } from '../utils/blogData';
import Odometer from './Odometer';

const GAMES = [
  { uid: '1116134862', name: 'animations: mocap', role: 'lead developer · full-stack, ui/ux', img: 'assets/mocap.png', href: 'https://www.roblox.com/games/3093229294' },
  { uid: '8371728708', name: 'jumped', role: 'lead developer · party game', img: 'assets/jumped.png', href: 'https://www.roblox.com/games/98592317434563' },
  { uid: '1742264997', name: 'scp: roleplay', role: 'ui/ux · conversion-optimised', img: 'assets/scp.png', href: 'https://www.roblox.com/games/5041144419' },
  { uid: '75587443', name: 'high school life', role: 'ui/ux · retention flows', img: 'assets/highschoollife.png', href: 'https://www.roblox.com/games/92604236' },
  { uid: '2132866904', name: 'frontlines', role: 'ui/ux · engagement flows', img: 'assets/frontlines.png', href: 'https://www.roblox.com/games/5938036553' },
  { uid: '81762198', name: 'vehicle simulator', role: 'ui/ux', img: 'assets/vehiclesim.png', href: 'https://www.roblox.com/games/171391948' },
  { uid: '1404342734', name: 'koha hibachi restaurant', role: 'ui/ux', img: 'assets/koha.png', href: 'https://www.roblox.com/games/4375619868' }
];

function DraftB() {
  const [visits, setVisits] = useState('…');
  const [playing, setPlaying] = useState('…');

  useEffect(() => {
    const noop = () => {};
    const pull = () => fetchRobloxData(setVisits, setPlaying, noop);
    pull();
    const id = setInterval(pull, 30000);
    return () => clearInterval(id);
  }, []);

  // mouse-tilt + cursor-following highlight on game tiles
  const handleTilt = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;
    e.currentTarget.style.setProperty('--rx', `${(0.5 - y) * 7}deg`);
    e.currentTarget.style.setProperty('--ry', `${(x - 0.5) * 7}deg`);
    e.currentTarget.style.setProperty('--shx', `${x * 100}%`);
    e.currentTarget.style.setProperty('--shy', `${y * 100}%`);
  };
  const resetTilt = (e) => {
    e.currentTarget.style.setProperty('--rx', '0deg');
    e.currentTarget.style.setProperty('--ry', '0deg');
  };

  return (
    <div className="app">
      <header className="hero">
        <div className="hero-left">
          <div className="hero-name">
            <img className="hero-avatar" src="assets/profile.jpg" alt="aayush parekh" />
            <h1>aayush parekh</h1>
          </div>
          <div className="head-socials" aria-label="contact">
            <a href="https://github.com/ap-logics" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56 0-.27-.01-1-.02-1.97-3.2.69-3.87-1.54-3.87-1.54-.52-1.33-1.28-1.68-1.28-1.68-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.03 1.76 2.7 1.25 3.36.95.1-.74.4-1.25.73-1.54-2.55-.29-5.24-1.28-5.24-5.7 0-1.26.45-2.29 1.18-3.1-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11.1 11.1 0 015.79 0c2.2-1.49 3.17-1.18 3.17-1.18.63 1.58.23 2.75.11 3.04.74.81 1.18 1.84 1.18 3.1 0 4.43-2.7 5.41-5.27 5.69.41.36.78 1.06.78 2.14 0 1.55-.01 2.8-.01 3.18 0 .31.21.67.8.56C20.21 21.38 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z"/>
              </svg>
            </a>
            <a href="https://twitter.com/perpspreads" target="_blank" rel="noopener noreferrer" aria-label="X">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M18.244 2H21l-6.55 7.49L22 22h-6.6l-5.16-6.74L4.3 22H1.54l7-8.01L1.5 2h6.76l4.66 6.16L18.244 2zm-1.16 18h1.72L7.02 4h-1.8l11.864 16z"/>
              </svg>
            </a>
            <a href="https://linkedin.com/in/parekhaayush" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M20.47 2H3.53A1.45 1.45 0 002.06 3.43v17.14A1.45 1.45 0 003.53 22h16.94a1.45 1.45 0 001.47-1.43V3.43A1.45 1.45 0 0020.47 2zM8.09 18.74h-3v-9h3zM6.59 8.48a1.56 1.56 0 110-3.12 1.57 1.57 0 110 3.12zm12.32 10.26h-3v-4.83c0-1.21-.43-2-1.52-2A1.65 1.65 0 0012.85 13a2 2 0 00-.1.73v5h-3v-9h3V11a3 3 0 012.71-1.5c2 0 3.45 1.29 3.45 4.06z"/>
              </svg>
            </a>
            <a href="assets/resume.pdf" target="_blank" rel="noopener noreferrer" aria-label="CV">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"/>
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 2v6h6M9 13h6M9 17h6"/>
              </svg>
            </a>
          </div>
          <div className="head-email">
            <a href="mailto:me@parekh.app">me@parekh.app</a>
          </div>

          <div className="games-flex top-stats" aria-label="all-time stats">
            <div className="gf-item">
              <span className="gf-big-num"><Odometer value={visits} /></span>
              <span className="gf-big-label">plays shipped</span>
            </div>
            <div className="gf-item">
              <span className="gf-big-num"><Odometer value={playing} /></span>
              <span className="gf-big-label">live right now</span>
            </div>
          </div>

          <section className="section">
            <div className="section-label">about</div>
            <div className="hero-bio">
              <p>
                i'm a final-year undergraduate studying <strong>mathematics with statistics</strong> at
                the <strong>university of nottingham</strong>. starting 2027/28 i'm heading to the{' '}
                <strong>university of warwick</strong> for a master's in statistics.
              </p>
              <p>
                in the meantime, this summer i'm joining{' '}
                <a className="bio-link" href="https://deepmind.google" target="_blank" rel="noopener noreferrer">google deepmind</a>{' '}
                as a
                research-ready intern at the university of nottingham, working on narrative-conditioned 3d human motion generation.
                and in the autumn i'm joining{' '}
                <a className="bio-link" href="https://www.hacktron.ai/" target="_blank" rel="noopener noreferrer">hacktron.ai</a>{' '}
                as a member of technical staff,
                building ai agents for security.
              </p>
              <p>
                i previously led development at sparkle.gg, a roblox studio with
                $500k+ revenue and 21k peak ccu. before that, i ran{' '}
                <a className="bio-link" href="https://www.roblox.com/games/3093229294/Animations-Mocap" target="_blank" rel="noopener noreferrer">animations: mocap</a>{' '}
                for six years (scaled up to $1m arr 2019-2023, with 3m+ mau and peak 16k ccu). last summer i interned as a quantitative
                researcher at{' '}
                <a className="bio-link" href="https://typhoon-trading.com/" target="_blank" rel="noopener noreferrer">typhoon trading</a>, doing stat-arb on crypto futures.
              </p>
              <p>
                i tried my hand at some quant trading firms too, landing springs at{' '}
                <strong>citadel, imc, de shaw, goldman sachs</strong>, etc.
              </p>
            </div>
          </section>

          <section className="section">
            <div className="section-label">research</div>
            <div className="entry">
              <a
                className="entry-title"
                href="https://deepmind.google"
                target="_blank"
                rel="noopener noreferrer"
              >
                MotionLM: Expressive Motion Generation from Narrative Text
                <span className="entry-arrow" aria-hidden="true">→</span>
              </a>
              <p className="entry-desc">
                part of the deepmind programme, supervised by{' '}
                <strong>dr stacy hsueh</strong>.
              </p>
            </div>
          </section>

          <section className="section">
            <div className="section-label">blog</div>
            {BLOG_POSTS.map((p) => (
              <div key={p.slug} className="entry">
                <a
                  className="entry-title"
                  href={`#/blog/${p.slug}`}
                >
                  {p.title.toLowerCase()}
                  <span className="entry-arrow" aria-hidden="true">→</span>
                </a>
              </div>
            ))}
          </section>

        </div>
      </header>

      <section className="games-section" aria-label="selected games">
        <div className="games-head">
          <span className="section-label">selected games</span>
        </div>

        <div className="games-grid">
          {GAMES.map((g) => (
            <a
              key={g.uid}
              className="gg-tile"
              href={g.href}
              target="_blank"
              rel="noopener noreferrer"
              onMouseMove={handleTilt}
              onMouseLeave={resetTilt}
            >
              <img src={g.img} alt="" />
              <span className="gg-name">{g.name}</span>
            </a>
          ))}
        </div>
      </section>
    </div>
  );
}

export default DraftB;
